import * as t from 'io-ts';

import { InvitationTypeC } from 'common/enums/invitation-type';

export const InvitationInfoC = t.exact(
  t.intersection([
    t.type({
      registered: t.boolean,
      isMe: t.boolean,
      id: t.number,
      email: t.string,
      confirmationKey: t.string,
      invitationType: InvitationTypeC,
      referHost: t.string,
      inviterId: t.string,
    }),
    t.partial({
      workPackageId: t.number,
      companyId: t.number,
    }),
  ]),
  'InvitationInfo');

export type InvitationInfo = t.TypeOf<typeof InvitationInfoC>;
